import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import env from 'configs/env';

declare global {
  interface Window {
    DD_LOGS?: typeof datadogLogs;
    DD_RUM?: typeof datadogRum;
  }
}

if (env.datadog && !window.DD_LOGS?.getInternalContext()) {
  try {
    datadogLogs.init({
      env: env.environment,
      silentMultipleInit: true,
      clientToken: env.datadog,
      site: 'datadoghq.com',
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      beforeSend: (log: any) => {
        // discard request cancel errors
        return !(
          (log?.http && log.http.status_code === 0 && log.http.method === 'POST') ||
          log?.error?.message?.includes('canceled') ||
          log?.error?.message?.includes('cancelled')
        );
      },
    });

    window.DD_LOGS = datadogLogs;
  } catch (error) {
    console.error('Failed to initialize datadogLogs:', error);
  }
}
